var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultCompany(_ref, svgRef) {
  var _ref2;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 61,
    viewBox: "0 0 51 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.53 0.5C31.0275 0.5075 31.5175 0.660001 31.935 0.952501C32.6025 1.42 33 2.185 33 3V58C33 59.37 31.8975 60.4825 30.5325 60.5H30.5H3C1.62 60.5 0.5 59.38 0.5 58C0.5 58 0.5 27.0825 0.5 16.5025C0.5 13.3475 2.4725 10.5325 5.4375 9.4525C12.7375 6.8 29.645 0.65 29.645 0.65C29.91 0.555 30.1825 0.505 30.455 0.5H30.4925H30.53ZM38 20.995L45.955 24.4025C48.7125 25.585 50.5 28.2975 50.5 31.2975V58C50.5 59.38 49.38 60.5 48 60.5H37.5725C37.85 59.7175 38 58.8775 38 58V20.995ZM20.5325 43C21.8975 42.9825 23 41.87 23 40.5C23 39.12 21.88 38 20.5 38H13C11.62 38 10.5 39.12 10.5 40.5C10.5 41.88 11.62 43 13 43H20.5H20.5325ZM20.5325 33C21.8975 32.9825 23 31.87 23 30.5C23 29.12 21.88 28 20.5 28H13C11.62 28 10.5 29.12 10.5 30.5C10.5 31.88 11.62 33 13 33H20.5H20.5325ZM20.5325 23C21.8975 22.9825 23 21.87 23 20.5C23 19.12 21.88 18 20.5 18H13C11.62 18 10.5 19.12 10.5 20.5C10.5 21.88 11.62 23 13 23H20.5H20.5325Z",
    fill: "#CCD5D3",
    style: (_ref2 = {
      fill: "#CCD5D3"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCompany);
export default __webpack_public_path__ + "static/media/default_company.9b45b124.svg";
export { ForwardRef as ReactComponent };